/** Select / stored values for user preference meeting location. */
export const MEETING_LOCATION_TYPE_VALUES = [
  'custom',
  'true',
  'meet',
  'phone',
  'address',
  'ms_teams',
] as const

export type MeetingLocationTypeValue =
  (typeof MEETING_LOCATION_TYPE_VALUES)[number]

const ALLOWED = new Set<string>(MEETING_LOCATION_TYPE_VALUES)

/**
 * Normalize a stored locationWiseZoomAdded value for the Meeting location select.
 * Maps legacy `false` → `custom` and unknown / corrupted values (e.g. `"undefined"`) → `custom`.
 */
export function normalizeMeetingLocationType(
  raw: unknown,
  fallback: MeetingLocationTypeValue = 'custom'
): MeetingLocationTypeValue {
  if (raw === null || raw === undefined || raw === '') {
    return fallback
  }

  const value = String(raw)
  if (value === 'false') {
    return 'custom'
  }
  if (value === 'undefined' || value === 'null' || !ALLOWED.has(value)) {
    return fallback
  }

  return value as MeetingLocationTypeValue
}

/** Value persisted on the user document for the current location. */
export function toStoredMeetingLocationType(
  uiType: string
): MeetingLocationTypeValue | 'false' {
  const normalized = normalizeMeetingLocationType(uiType)
  return normalized === 'custom' ? 'false' : normalized
}
